/* © 2026 Trinchebalk */
(() => {
  // Styling the app's existing button preserves its handler and country gate.
  const styleCod = () => document.querySelectorAll('tb-a-product[data-cod-label]').forEach(product => {
    const cod = product.querySelector('#rsi_buy_now_button');
    if (!cod || !product.dataset.codLabel) return;
    const walker = document.createTreeWalker(cod, NodeFilter.SHOW_TEXT);
    let text; while ((text = walker.nextNode())) if (/PAG(?:A|HI) ALLA CONSEGNA/i.test(text.textContent)) { if (text.textContent !== product.dataset.codLabel) text.textContent = product.dataset.codLabel; break; }
    cod.setAttribute('aria-label', product.dataset.codLabel); cod.dataset.tbCodLabel = product.dataset.codLabel;
  });
  // The builder owns immutable v2 fields. The app's v1 UI lives outside the form.
  const sync = () => {
    styleCod();
    document.querySelectorAll('tb-a-product').forEach(product => {
      if (product.dataset.initError === 'true') return;
      if (!product.form || !product.querySelector('[data-kit]')) return;
      product.updateKit(); product.guard();
    });
  };
  document.addEventListener('DOMContentLoaded', sync);
  window.addEventListener('pageshow', sync);
  new MutationObserver(styleCod).observe(document.body, { childList: true, subtree: true });
  sync();
})();
